import update from 'immutability-helper';

export default function setFilters(state, action) {
  const { options } = action;
  let filters = {};

  // clear the filters
  if (action.clear) {
    filters = {
      startTime: state.filters.startTime,
      endTime: state.filters.endTime,
      users: null,
      templates: null,
      set: false,
    };
    setLocalStorage(filters);

    return update(state, {
      filters: {
        startTime: {
          $set: filters.startTime,
        },
        endTime: {
          $set: filters.endTime,
        },
        users: {
          $set: null,
        },
        templates: {
          $set: null,
        },
        set: {
          $set: false,
        },
      },
    });
  }

  const from = options.startTime || state.filters.startTime;
  const to = options.endTime || state.filters.endTime;
  const users = options.users || state.filters.users;
  const templates = options.templates || state.filters.templates;

  // filters are only set if we have something other than dates
  let filtersSet = false;

  if (templates || users) {
    filtersSet = true;
  }

  filters = {
    startTime: from,
    endTime: to,
    users: users,
    templates: templates,
    set: filtersSet,
  };

  setLocalStorage(filters);

  return update(state, {
    filters: {
      startTime: {
        $set: from,
      },
      endTime: {
        $set: to,
      },
      users: {
        $set: users,
      },
      templates: {
        $set: templates,
      },
      set: {
        $set: filtersSet,
      },
    },
  });

  function setLocalStorage(filters) {
    const projectId = state.project.id;
    if (typeof Storage !== undefined) {
      localStorage.setItem(
        `ape_liveview_filters_${projectId}`,
        JSON.stringify(filters)
      );
    }
  }
}
